module.exports = __webpack_public_path__ + "img/ws.21d61e76.webp";